<template>
    <div class="socialfacebook-box">
        <div class="facebook-box">
            <!-- 行走的线 -->
            <div class="animetionLine"></div>
            <div class="imglogo-box" :style='{backgroundImage:"url("+socialmediaData.rightData.imgurl+")"}'></div>
            <div class="right-center">{{socialmediaData.rightData.center}}</div>
            <ul class="right-ul">
                <li class="right-li" v-for='(item,index) in socialmediaData.rightData.listData' :key='index'>
                    <div class="icon" :style='{backgroundImage:"url("+item.icon+")"}'></div>
                    <div class="numbertitle">{{item.title}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'SocialFacebook',
        data() {
            return {
                socialmediaData: {
                    rightData: {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/d90bb140efea8c09f6fe699f0bcac25f.jpg',
                        center: 'Facebook是美国的一个社交网络服务网站每月活跃用户超过30亿',
                        listData: [
                            {
                                icon: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/dianpuguanli.png',
                                title: 'Facebook店铺运营'
                            },
                            {
                                icon: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/wodefensi.png',
                                title: 'Facebook粉丝运营'
                            },
                            {
                                icon: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/cehua_1.png',
                                title: 'Facebook活动策划'
                            }
                        ]
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .socialfacebook-box {
        position: relative;
        padding-bottom: 156px;
    }

    .imglogo-box {
        height: 105px;
        width: 112px;
        background: #ffffff no-repeat center center;
        background-size: cover;
    }

    .right-center {
        max-width: 454px;
        font-size: 24px;
        font-weight: bold;
        line-height: 42px;
        color: rgba(102, 102, 102, 1);
        margin: 26px 0 63px 0;
        text-align: center;
    }

    .right-ul {
        display: flex;
        width: 62.4%;
        justify-content: space-between;
    }

    .right-li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .icon {
        width: 45px;
        height: 45px;
        background: transparent no-repeat center center;
        background-size: cover;
        margin-bottom: 20px;
    }

    .numbertitle {
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        color: rgba(112, 112, 112, 1);
        text-align: center;
        max-width: 89px;
        background-color: transparent;
    }

    .facebook-box {
        width: 47.3%;
        min-height: 613px;
        padding: 5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        margin-top: 143px;
        margin-left: 150px;
        position: relative;
        z-index: 3;
    }

    .socialfacebook-box::before {
        content: "";
        display: block;
        width: 53%;
        height: 34vw;
        position: absolute;
        top: 0;
        right: 0;
        transform: translateY(-143px);
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/u%3D2348866973%2C4280688045%26fm%3D214%26gp%3D0.jpg') no-repeat center;
        background-size:cover;
    }

    .facebook-box::after {
        content: 'Blue  Whale';
        white-space: nowrap;
        display: block;
        color: #E5E5E5;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        transform: translateX(-303%) rotate(90deg);
        position: absolute;
        top: 80px;
        left: 30%;
    }

    .animetionLine {
        width: 46px;
        height: 14px;
        position: absolute;
        top: 158px;
        left: 30%;
        transform: translateX(-500%) rotate(90deg);
        overflow: hidden;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: block;
        transform: rotate(90deg);
        width: 1px;
        height: 46px;
        background-color: #E5E5E5;
        position: absolute;
        top: -110%;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            right: 150%;
        }

        to {
            right: -52%;
        }
    }

    @media(max-width: 995px){
        .socialfacebook-box {
        padding-bottom:10%;
    }
        .socialfacebook-box::before {
        display: none;
    }
    .facebook-box {
        width:100%;
        min-height:auto;
        padding: 5%;
        margin: 0;
    }
    .facebook-box::after,.animetionLine {
        display: none;
    }
    .imglogo-box {
        height: 50px;
        width: 50px;
    }
    .right-center {
        max-width: 100%;
        font-size: 16px;
        font-weight: bold;
        line-height: 175%;
        margin:5% 0;
    }
    .right-ul {
        width: 100%;
    }
    }

    /* @media(max-width: 1023px) {
        .socialfacebook-box {
        padding-bottom: 0;
        margin-top: 5%;
    }
        .socialfacebook-box::before {
            display: none;
        }

        .facebook-box {
            width: 100%;
            height: 1200px;
            margin-top: 0;
            margin-left: 0;
        }

        .imglogo-box {
            height: 205px;
            width: 312px;
        }

        .right-center {
            max-width: 67%;
            font-size: 50px;
            line-height: 175%;
        }

        .icon {
            width: 120px;
            height: 120px;
            margin-bottom: 20px;
        }

        .numbertitle {
            font-size: 50px;
            line-height: 137%;
            max-width: 65%;
        }

        .right-ul {
            display: flex;
            width: 70%;
            justify-content: space-between;
        }

    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/socialfacebook.vue